<template>
  <div>
    <banners :banners="banners" :title="title" />
    <div class="landing-page">
      <div class="landing-page__container">
        <div class="landing-page__description">
          <h2 class="landing-page__description-title">
            {{ $t('landing_pages.iphone_15.first_title') }}
          </h2>
          <p
            class="landing-page__description-subtitle"
            v-html="$t('landing_pages.iphone_15.first_description')"
          ></p>
        </div>
        <div v-if="$isBrStore || isSubstore" class="landing-page__hero-banner">
          <img :src="heroBanner" alt="iPhone 15" />
        </div>
        <div v-else>
          <div class="landing-page__wrapper-container">
            <div class="landing-page__wrapper">
              <div class="landing-page__gallery">
                <a
                  v-for="(miniHeroBanner, index) in miniHeroBannersGlobal"
                  :key="index"
                  class="landing-page__gallery-item"
                  :href="miniHeroBanner.redirectLink"
                  rel="noopener"
                >
                  <img :src="miniHeroBanner.src" :alt="miniHeroBanner.alt" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <shelf :shelf-products="shelf" :use-cache="false" :first-shelf="true" />
      <div class="landing-page__container">
        <div
          v-if="$isBrStore || isSubstore"
          style="display: flex; flex-direction: column; align-items: center"
        >
          <div class="landing-page__description">
            <h2 class="landing-page__description-title">
              {{ $t('landing_pages.iphone_15.second_title') }}
            </h2>
            <p
              class="landing-page__description-subtitle"
              v-html="$t('landing_pages.iphone_15.second_description')"
            ></p>
          </div>

          <div class="landing-page__wrapper-container">
            <div class="landing-page__wrapper">
              <div class="landing-page__gallery">
                <a
                  v-for="(minibanner, index) in minibanners"
                  :key="index"
                  class="landing-page__gallery-item"
                  :href="minibanner.redirectLink"
                  rel="noopener"
                >
                  <img :src="minibanner.src" :alt="minibanner.alt" />
                </a>
              </div>
            </div>
          </div>

          <div class="landing-page__description">
            <h2 class="landing-page__description-title">
              {{ $t('landing_pages.iphone_15.third_title') }}
            </h2>
          </div>

          <div class="landing-page__wrapper-container">
            <div class="landing-page__wrapper">
              <div class="landing-page__gallery">
                <a
                  v-for="(comparativeMinibanner,
                  index) in comparativeMinibanners"
                  :key="index"
                  class="landing-page__gallery-item"
                  :href="comparativeMinibanner.redirectLink"
                >
                  <img
                    :src="comparativeMinibanner.src"
                    :alt="comparativeMinibanner.alt"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="landing-page__description">
          <h2 class="landing-page__description-title">
            {{ $t('landing_pages.iphone_15.fourth_title') }}
          </h2>
          <p
            class="landing-page__description-subtitle"
            v-html="$t('landing_pages.iphone_15.fourth_description')"
          ></p>
        </div>

        <div class="landing-page__hero-banner">
          <img :src="lastHeroBanner" alt="iPhone 15" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Shelf from '~/components/pages/shelf/Shelf.vue'
import Banners from '~/components/pages/banners/Banners.vue'
export default {
  components: {
    Shelf,
    Banners,
  },
  data() {
    return {
      title: 'iPhone 15',
    }
  },
  computed: {
    storeInfo() {
      return this.$store.getters.storeInfo
    },
    shelf() {
      return {
        id: 3300,
        label: this.$t('landing_pages.iphone_15.shelf_title'),
        see_more: this.$isBrStore
          ? 'https://www.gocase.com.br/capinhas-para-celular/iphone-15-pro-max/'
          : this.isSubstore
          ? '/capinhas-para-celular/iphone-15-pro-max'
          : 'https://www.gocase.com/smartphone-cases/iphone-15-pro-max-nl',
        type: 'custom',
      }
    },
    isGlobalStore() {
      return !(
        this.$isBrStore || this.$store.getters.storeInfo?.substore === 'us'
      )
    },
    isSubstore() {
      return this.$store.getters.storeInfo?.substore === 'us'
    },
    banners() {
      const bannersBr = [
        {
          name: 'Iphone 15',
          link_url:
            'https://www.gocase.com.br/capinhas-para-celular/iphone-15-pro-max/',
          desktop_image:
            'https://static-goengines.gocase.com.br/qr-img/227809022097402061695410854219.png',
          mobile_image:
            'https://static-goengines.gocase.com.br/qr-img/41225136867339131695410899626.jpeg',
        },
      ]

      const bannersSubstore = [
        {
          name: 'Iphone 15',
          link_url:
            'https://us.gocase.com/capinhas-para-celular/iphone-15-pro-max',
          desktop_image:
            'https://static-goengines.gocase.com.br/qr-img/91573219362791461695411474112.png',
          mobile_image:
            'https://static-goengines.gocase.com.br/qr-img/7351205134762141695411537080.jpeg',
        },
      ]

      const bannersGlobal = [
        {
          name: 'Iphone 15',
          link_url:
            'https://www.gocase.com/smartphone-cases/iphone-15-pro-max-nl',
          desktop_image:
            'https://static-goengines.gocase.com.br/qr-img/21566416661397071694465713780.png',
          mobile_image:
            'https://static-goengines.gocase.com.br/qr-img/0064984388292863571694465951329.jpeg',
        },
      ]

      return this.$isBrStore
        ? bannersBr
        : this.isSubstore
        ? bannersSubstore
        : bannersGlobal
    },
    heroBanner() {
      const heroBannerBr =
        'https://static-goengines.gocase.com.br/qr-img/82174971890847391693591717156.jpeg'

      const heroBannerSubstore =
        'https://static-goengines.gocase.com.br/qr-img/088545233461409411695411750334.jpeg'

      const heroBannerGlobal = ''

      return this.$isBrStore
        ? heroBannerBr
        : this.isSubstore
        ? heroBannerSubstore
        : heroBannerGlobal
    },
    minibanners() {
      const minibannersBr = [
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/52982144700653431695411412260.png',
          alt: 'Slim Air',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/iphone-15-pro-max/?case_device=antiimpactoslimair-iphone15promax',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/0392466483152011941695411342386.png',
          alt: 'Guard Clear [Magsafe]',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/iphone-15-pro-max/?case_device=caseslimguardmagsafe-iphone15promax',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/33231807071225151695411173239.png',
          alt: 'Slim Black',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/iphone-15-pro-max/',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/87647066869975031695411266175.png',
          alt: 'Gocase Duo',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/iphone-15-pro-max/',
        },
      ]

      const minibannersSubstore = [
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/27087274243341851695413086398.png',
          alt: 'Shockproof Clear',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/iphone-15-pro-max',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/0252381721687184871695413129309.png',
          alt: 'Crystal Glow MagSafe',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/iphone-15-pro-max',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/379521497957687971695413035638.png',
          alt: 'Shockproof Black',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/iphone-15-pro-max',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/76137131535678511695413247056.png',
          alt: 'UltraGuard',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/iphone-15-pro-max',
        },
      ]

      return this.$isBrStore ? minibannersBr : minibannersSubstore
    },
    comparativeMinibanners() {
      const comparativeMinibannersBr = [
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/76859665813038511693876253736.jpeg',
          alt: 'Shockproof Clear',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/iphone-15-pro-max/',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/148354472596695651693876130467.jpeg',
          alt: 'Guard Clear [Magsafe]',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/iphone-15-pro-max/',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/94540726786007221693876235923.jpeg',
          alt: 'Slim Black',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/iphone-15-pro-max/',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/96249088674291981693876271444.jpeg',
          alt: 'Gocase Duo',
          redirectLink:
            'https://www.gocase.com.br/capinhas-para-celular/iphone-15-pro-max/',
        },
      ]

      const comparativeMinibannersSubstore = [
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/31023345818134531695413552825.jpeg',
          alt: 'Slim Air',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/iphone-15-pro-max',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/76665054208294481695413453689.jpeg',
          alt: 'Crystal Glow MagSafe',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/iphone-15-pro-max',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/99422868168372471695413402643.jpeg',
          alt: 'Shockproof Black',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/iphone-15-pro-max',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/33462231579894851695413506250.jpeg',
          alt: 'UltraGuard',
          redirectLink:
            'https://us.gocase.com/capinhas-para-celular/iphone-15-pro-max',
        },
      ]

      return this.$isBrStore
        ? comparativeMinibannersBr
        : comparativeMinibannersSubstore
    },
    miniHeroBannersGlobal() {
      return [
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/93126643586916621694466624627.jpeg',
          alt: 'Slim Black',
          redirectLink:
            'https://www.gocase.com/smartphone-cases/iphone-15-pro-max-nl',
        },
        {
          src:
            'https://static-goengines.gocase.com.br/qr-img/458242823893533441694466604884.jpeg',
          alt: 'Slim Air',
          redirectLink:
            'https://www.gocase.com/smartphone-cases/iphone-15-pro-max-nl',
        },
      ]
    },
    lastHeroBanner() {
      const lastHeroBannerBr =
        'https://static-goengines.gocase.com.br/qr-img/08433372143144081693596741179.jpeg'

      const lastHeroBannerSubstoreAndGLobal =
        'https://static-goengines.gocase.com.br/qr-img/67975154402777771695737240005.jpeg'

      return this.$isBrStore
        ? lastHeroBannerBr
        : lastHeroBannerSubstoreAndGLobal
    },
  },
  head() {
    return {
      title: this.title,
    }
  },
}
</script>

<style lang="scss" scoped>
.landing-page {
  background-color: #fcfdf7;
  position: relative;
  min-height: 399px;
  color: #000 !important;

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &__description {
    text-align: center;
    margin: 42px 15px;

    &-title {
      font-size: 36px;
      margin: 0px !important;
    }

    &-subtitle {
      font-size: 20px;
      font-weight: 300;
      margin: 5px 0 5px 0 !important;
      max-width: 800px;
    }
  }

  &__hero-banner {
    width: 100%;

    img {
      overflow-clip-margin: content-box;
      overflow: clip;
      width: 100%;
    }
  }
}

.landing-page__wrapper-container {
  position: relative;

  .landing-page__wrapper {
    overflow-x: auto;

    .landing-page__gallery {
      display: flex;
      flex-flow: row nowrap;
      gap: 15px;

      .landing-page__gallery-item {
        cursor: pointer;
        flex-shrink: 0;

        img {
          width: 100%;
        }
      }
    }
  }
}

img {
  overflow-clip-margin: content-box;
  overflow: clip;
}
.landing-page__wrapper::-webkit-scrollbar {
  display: none;
}

.landing-page__wrapper {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.landing-page__gallery-item:first-child {
  padding-left: 15px;
}

.landing-page__gallery-item:nth-last-child(1) {
  padding-right: 15px;
}

@media (min-width: 768px) {
  .landing-page {
    &__description {
      text-align: center;
      margin: 42px 0px;

      &-title {
        font-size: 40px;
      }

      &-subtitle {
        font-size: 24px;
        font-weight: 300;
        margin: 5px 0 5px 0 !important;
        max-width: 800px;
      }
    }
  }
  .landing-page__container {
    width: 1170px;
    margin-right: auto;
    margin-left: auto;
  }

  .landing-page__wrapper-container {
    position: relative;
    margin: 0px;

    .landing-page__wrapper {
      .landing-page__gallery {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;

        .landing-page__gallery-item {
          cursor: pointer;
          flex-shrink: 1;

          img {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
